"use client";

import Image from "next/image";
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import { BsCursorFill } from "react-icons/bs";
import { IoIosStar } from "react-icons/io";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

import "./WebAppHeroSection.scss";

import CTAButton from "@/components/CTAButton/CTAButtons";
import overview from "@/assets/images/services/web-app/heroImg.webp";

const WebAppHeroSection = ({ data }) => {
  const { title, description, statitems } = data;

  const { ref, inView } = useInView({
    threshold: 0.4,
    triggerOnce: false,
  });

  const formattedStats = statitems?.map((stat) => ({
    ...stat,
    value: parseFloat(stat.value),
    suffix: stat.value.replace(/[0-9.]/g, ""),
    decimals: stat.value.includes(".") ? 1 : 0,
  }));

  return (
    <section
      className="web-hero-section"
      ref={ref}
    >
      <Container>
        <div className="hero-inner">
          <div className="floating-timesheet">
            <BsCursorFill />
            <p>Offline Ready</p>
          </div>

          <div className="floating-planning">
            <BsCursorFill />
            <p>Mobile First</p>
          </div>

          <div className="web-text-content">
            <h1 className="web-hero-title">{title}</h1>

            <p className="web-hero-description">{description}</p>

            <div className="stats-wrapper">
              {formattedStats?.map((stat, index) => (
                <div
                  key={stat.label}
                  className="stat-item"
                >
                  <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 + 0.3 }}
                    className="stat-value"
                  >
                    {inView ? (
                      <CountUp
                        end={stat.value}
                        duration={2}
                        decimals={stat.decimals}
                      />
                    ) : (
                      0
                    )}
                    {stat.suffix}
                  </motion.span>

                  <span className="stat-label">{stat.label}</span>

                  {index !== formattedStats.length - 1 && (
                    <div className="stat-divider" />
                  )}
                </div>
              ))}
            </div>

            <CTAButton
              primaryText="Start your project"
              secondaryText="Watch a Demo"
            />

            <div className="rating-wrap">
              <div className="trust-star-wrap">
                <IoIosStar className="trust-star" />
                <span>Trustpilot</span>
              </div>

              <div className="rating-group">
                <IoIosStar />
                <IoIosStar />
                <IoIosStar />
                <IoIosStar />
                <IoIosStar />

                <span className="rating-count">3800+ 5 Stars</span>
              </div>
            </div>
          </div>

          <motion.div
            className="hero-image-wrapper"
            initial={{ opacity: 0, y: 80 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <Image
              src={overview}
              alt="Web App Overview"
              className="hero-image"
              priority
            />
          </motion.div>
        </div>
      </Container>
    </section>
  );
};

export default WebAppHeroSection;